import { sendUserEligibilityEvent } from 'core/services/email/blueshift/implementations/eligibility'

function trackingHealthSherpa() {
  sendUserEligibilityEvent()
  // this is a stand-alone script, initPage() is not called before
  const smartlySDK = window.hc.smartlySDK
  if (smartlySDK) {
    smartlySDK.ready().then(() => {
      smartlySDK.track('ph_action_redirect_health_sherpa')
      smartlySDK.publish()
    })
  }
}

export default trackingHealthSherpa
